<div class="row vertical-center flex max-width">
  <ng-content></ng-content>
  <a class="type-toggle ion-justify-content-center" (click)="toggleShow()">
    <i class="{{ showPassword ? 'fas fa-eye-slash show-option' : 'fas fa-eye hide-option' }}"></i>
  </a>
</div>
